import React, { useEffect, useState } from "react";
import ItemSizeModel from "../../../models/ItemSizeModel";

interface IProps {
    onShowEditPopup: () => void
    itemSize: ItemSizeModel
}

const ItemRevisionSizeControl: React.FC<IProps> = ({ onShowEditPopup, itemSize }) => {
    const [itemRevisionSize, setItemRevisionSize] = useState(itemSize)

    useEffect(() => {
        setItemRevisionSize(itemSize)
    }, [itemSize])

    return (
        <div className='item-size' onClick={onShowEditPopup}>{itemRevisionSize.size.name}</div>
    );
}
export default ItemRevisionSizeControl;
